import { render, staticRenderFns } from "./belumMemilikiRumah.vue?vue&type=template&id=002e7a80&"
import script from "./belumMemilikiRumah.vue?vue&type=script&lang=js&"
export * from "./belumMemilikiRumah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports